import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button/Button';
import { withStyles } from '@material-ui/core/styles';

import { toggleAddProgrammePopup } from '../redux/reducers/view';
import { commonStyles } from '../styles/styles';

const AddCodeButton = ({ classes, toggleAddProgrammePopup }) => (
  <Button
    variant="contained"
    className={`${classes.greyButton} ${classes.button}`}
    onClick={() => toggleAddProgrammePopup(true)}
  >
    Add programme
  </Button>
);

const styles = () => ({
  ...commonStyles,
  button: {
    width: 130,
    height: 30,
  },
});

const mapStateToProps = state => ({
  login: state.loginReducer,
  view: state.viewReducer,
});
const mapDispatchToProps = dispatch => ({
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
)(AddCodeButton);

AddCodeButton.propTypes = {
  classes: PropTypes.instanceOf(Object),
  toggleAddProgrammePopup: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Components/AddCodeButton.jsx